import request from '../request';

function toQuery(params) {
	return Object.keys(params || {})
		.filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
		.join('&');
}

// ---- shared with web2 ----

export function getGlobalSetting() {
	return request({ url: 'api/global/lookup', method: 'get', noAuth: true });
}

export function getMemberInfo() {
	return request({ url: 'api/member/get-member-info', method: 'get' });
}

export function setLanguage(postData) {
	return request({ url: 'api/member/setLanguage', method: 'post', data: postData });
}

// wallet: point17 (币质押钱包) / point18 (币释放钱包)
export function getUserWalletRecord(params) {
	return request({ url: 'api/record/wallet-record?' + toQuery(params), method: 'get' });
}

// ---- coin ----

// sec_password, amount (NGT1)
export function convertCoin(postData) {
	return request({ url: 'api/coin/convertCoin', method: 'post', data: postData });
}

export function convertCoinRecord(params) {
	return request({ url: 'api/coin/convertCoinRecord?' + toQuery(params), method: 'get' });
}
